import { Link } from 'react-router-dom';
import { siteConfig, navLinks } from '@/mocks/site';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="text-xl font-bold font-heading text-foreground-950">
              {siteConfig.name}
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              {siteConfig.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <div className="flex flex-wrap gap-2">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
            <div className="mt-4 text-xs text-foreground-500">
              联系邮箱：{siteConfig.contactInfo.email}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name}. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-500">
            用爱和理解，共创温馨家庭
          </p>
        </div>
      </div>
    </footer>
  );
}